module.exports = __webpack_public_path__ + "static/media/fans.d8cdbedc.png";